import React from 'react';
import PropTypes from 'prop-types';

// import Heading from 'components/shared/heading';
import Button from 'components/shared/button';

import styles from './styles.module.scss';
import { BUILDING_TYPES } from '../../../config';

const ReviewSubmit = ({ step1Data, step2Data, onSubmit, isSubmitting, onBack }) => {
  const getBuildingTypeLabel = (value) => {
    if (value === 'other') {
      return step1Data.buildingTypeOther || 'Other';
    }
    return BUILDING_TYPES.find((t) => t.value === value)?.label || value;
  };

  const handleSubmit = () => {
    const allData = {
      ...step1Data,
      ...step2Data,
    };
    onSubmit(allData);
  };

  return (
    <div className={styles.reviewSubmit} id="estimate-review-submit">
      {/* <Heading className={styles.stepTitle} tag="h3" size="md">
        Review & Submit
      </Heading> */}

      <div className={styles.reviewSection}>
        <div className={styles.summary}>
          <h4>Project Summary</h4>
          <div className={styles.summaryItems}>
            <div className={styles.summaryItem}>
              <span>Building Type:</span>
              <span>{getBuildingTypeLabel(step1Data.buildingType)}</span>
            </div>
            <div className={styles.summaryItem}>
              <span>Contact Name:</span>
              <span>
                {step1Data.firstName} {step1Data.lastName}
              </span>
            </div>
            <div className={styles.summaryItem}>
              <span>Email:</span>
              <span>{step1Data.contactEmail}</span>
            </div>
            {step1Data.phone && (
              <div className={styles.summaryItem}>
                <span>Phone:</span>
                <span>{step1Data.phone}</span>
              </div>
            )}
            {step1Data.buildingAddress && (
              <div className={styles.summaryItem}>
                <span>Address:</span>
                <span>{step1Data.buildingAddress}</span>
              </div>
            )}
          </div>
        </div>

        <div className={styles.scopeSummary}>
          <h4>Scope Summary</h4>
          <div className={styles.scopeItems}>
            {step2Data.intercoms > 0 && (
              <div className={styles.scopeItem}>
                <span>Intercoms:</span>
                <span>{step2Data.intercoms} units</span>
              </div>
            )}
            {step2Data.cardReaders > 0 && (
              <div className={styles.scopeItem}>
                <span>Card Readers:</span>
                <span>{step2Data.cardReaders} units</span>
              </div>
            )}
            {step2Data.vehicleReaders > 0 && (
              <div className={styles.scopeItem}>
                <span>Vehicle Readers:</span>
                <span>{step2Data.vehicleReaders} units</span>
              </div>
            )}
            {step2Data.smartLocks > 0 && (
              <div className={styles.scopeItem}>
                <span>Smart Locks:</span>
                <span>{step2Data.smartLocks} units</span>
              </div>
            )}
            {step2Data.elevatorAccess && (
              <div className={styles.scopeItem}>
                <span>Elevator Access Control:</span>
                <span>Included</span>
              </div>
            )}
            {step2Data.installationNeeded && (
              <div className={styles.scopeItem}>
                <span>Installation Services:</span>
                <span>Included</span>
              </div>
            )}
            <div className={styles.scopeItem}>
              <span>Construction Type:</span>
              <span>
                {step2Data.constructionType === 'existing' ? 'Existing System' : 'New Construction'}
              </span>
            </div>
            {step2Data.camerasNeeded && (
              <div className={styles.scopeItem}>
                <span>Cameras:</span>
                <span>Included</span>
              </div>
            )}
          </div>
        </div>

        <div className={styles.disclaimers}>
          <p>
            <strong>Important Notes:</strong>
          </p>
          <ul>
            <li>
              This is an estimate only; final pricing depends on building layout and site design
            </li>
            <li>Taxes, shipping, accessories, power supplies, and controllers are excluded</li>
          </ul>
        </div>
      </div>

      <div className={styles.navigation}>
        <Button theme="secondary" type="button" onClick={onBack}>
          Back
        </Button>
        <Button theme="accent-primary" onClick={handleSubmit} loading={isSubmitting}>
          Build Quote
        </Button>
      </div>
    </div>
  );
};

ReviewSubmit.propTypes = {
  step1Data: PropTypes.object.isRequired,
  step2Data: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default ReviewSubmit;
